import QueryString from '@/utils/QueryString'

/**
 * This class represents a nasty WFFM construct that is supposed to be automatically
 * submitted if exists on the page. It does automatic confirmation that the user has
 * properly subscribed to newsletter.
 */
export default class AutoconfirmationForm {
  /**
   * @param {HTMLFormElement} root
   */
  constructor (root) {
    this.root = root
    this.data = root.querySelector('.text-box.single-line')
  }

  exists = () => this.hasProperURL() && this.hasControlData() && this.hasUserData()
  hide = () => { this.root.style.display = 'none' }
  submit = () => { this.root.submit() }

  hasControlData = () => this.data != null
  hasProperURL = () => window.location.pathname.indexOf('/newsletter-potwierdzenie') > -1
  hasUserData = () => new QueryString().exists('u')
}



// WEBPACK FOOTER //
// ./src/components/newsletter/AutoconfirmationForm.js